const language = {
	spanish: {
		header_title: "Distribución",
		distribucion_red_title: "DISTRIBUCIÓN",
		distribucion_bold_title:
			"Contamos con varias soluciones para hacer más eficiente la logística de despacho de cualquier empresa sin importar el tamaño de la operación. Nuestra solución es configurable a todas a todo tipo de operación",
		distribucion_text:
			"Además, ¡Nuestro servicio incluye una aplicación con POD! Con ella puede tener un registro fotográfico en tiempo real sobre lo que está pasando en campo y así hacer mejorar auditorías.",
		solucion_1:
			"Aumenta la satisfacción del cliente con un equipo de distribución más informado.",
		solucion_2:
			"Evalúe el comportamiento de los conductores tras el volante y proteja la carga y las unidades de distribución.",
		solucion_3:
			"Seguimiento y cumplimiento de rutas en tiempo real desde la web o aplicaciones móviles.",
		solucion_4:
			"Reducción de papel por digitalización de bitácoras de entregas para conductores.",
		solucion_5:
			"Incremente la eficiencia del combustibles con un mayor control sobre la actividad de las unidades (Tiempo en ruta y ralentí).",
		solucion_6:
			"Reduzca los inconvenientes logísticos tras despachos no planificados.",
		caracteristica_red_title: "CARACTERÍSTICAS",
		caracteristica_bold_text:
			"Cuando sabe dónde están sus conductores en cualquier momento, puede realizar envíos de manera más eficiente, mejorar el servicio al cliente y dedicar menos tiempo a llamar a los conductores para obtener actualizaciones.",
		caracteristica_list: [
			{
				text: "Sistema de localización vía GPS y dispositivos móviles.",
				column: "1",
			},
			{
				text: "Generador de geocercas, puntos de interés y rutas.",
				column: "1",
			},
			{
				text: "Visibilidad de vehículos sobre mapas digitalizados y fotos satelitales (Google Maps y OSM).",
				column: "1",
			},
			{
				text: "Entregar un mejor ETA a sus clientes.",
				column: "1",
			},
			{
				text: "Poderosa app móvil para conductores que colecciona pruebas de entregas (POD): fotografías de incidencias, entregas, firmas de clientes y encuestas de satisfacción.",
				column: "1",
			},
			{
				text: "Oriente a sus conductores con la dirección exacta de los clientes sobre mapas digitalizados en cualquier dispositivo.",
				column: "1",
			},
			{
				text: "Diversidad de reportes de gestión de conductores y flotas.",
				column: "1",
			},
			{
				text: "Programar envío recurrente de reportes.",
				column: "2",
			},
			{
				text: "Alertas en tiempo real de incidencias de seguridad y logística.",
				column: "2",
			},
			{
				text: "Apagado remoto del vehículo y detección de manipulación del dispositivo.",
				column: "2",
			},
			{
				text: "Manejo de distintos tipos de vehículos.",
				column: "2",
			},
			{
				text: "Gestión de horas de manejo por conductor.",
				column: "2",
			},
			{
				text: "Administración de usuarios por roles.",
				column: "2",
			},
		],
		funcionalidades_red_title: "FUNCIONALIDADES ESPECIALES",
		funcionalidades_bold_text:
			"Foresight GPS ha desarrollado integraciones con distintos tipos de periféricos y sensores de la más amplia gama en marcas, modelos y funcionalidades.",
		funcionalidades_text: [
			"Esto dota de una gran versatilidad al sistema y le permite controlar variables y establecer acciones de forma remota.",
			"Desde la detección de un consumo atípico de combustible, pasando por un reporte detallado del comportamiento del motor y una medición de variaciones de temperatura de carga refrigerada. Incluso desde Foresight GPS podemos hacer nuevos desarrollos para integrar cualquier otro tipo de dispositivo.",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Fue diseñado para visualizar los indicadores clave de rendimiento de forma rápida y eficiente, facilitando la toma de decisiones ante grandes volúmenes de datos.",
		dashboard_text: [
			"Con distintos conjuntos de tableros puedes ver la velocidad media, máxima y promedio de la flota, el kilometraje por unidad, el consumo de combustible promedio individual o por flota, las horas del motor encendido y el tiempo en los viajes, y más.",
			"Además se pueden incluir nuevos sets de datos y personalizar los Dashboard a las necesidad específicas de cada operación.",
		],
		dashboard_list: [
			"Procesamiento de data.",
			"Presentación gráfica de resultados.",
			"Comparativo de resultados entre diferentes vehículos.",
			"Identificador de variables fuera de rango.",
			"Interfaz gráfica amigable y fácil de leer.",
			"Control de múltiples variables de manera simultánea.",
			"Información discriminada en piloto/embarcación y flota.",
		],
		rutas_bold_text:
			"Llevar un control de las rutas de los conductores ayuda a completar más tareas en menos tiempo mientras mantienen contentos a sus clientes y reduce costos operativos.",
		rutas_text: [
			"La planificación diaria no tiene porqué ser un dolor de cabeza con nuestro módulo de Route Center. A su vez, incrementa la puntualidad en las entregas y disfruta de una gestión eficiente.",
			"Mediante la planificación, el diseño y la asignación de ruta, gerencia el trabajo de tu flota de una manera eficiente.",
			"Realiza un seguimiento de las rutas y la actividad diaria de la flota y sus rutas en tiempo real o a través de reportes lleva el seguimiento de tu flota y valida el cumplimiento de tarea.",
		],
		rutas_list: [
			"Mapeo de clientes y zonas de despacho.",
			"Creación de rutas.",
			"Planificación de visitas.",
			"Verificación de patrones de visitas.",
			"Variedad de reportes ejecutados.",
			"Visualización de avances de gestión de pantalla.",
		],
	},
	english: {
		header_title: "Distribution",
		distribucion_red_title: "DISTRIBUTION",
		distribucion_bold_title:
			"We have several solutions to streamline dispatch logistics for any company regardless of the size of the operation. Our solution is customizable to all types of operations",
		distribucion_text:
			"Also, ¡Our service includes an app with proof of delivery POD! with this you can have a photographic record in real time about what is happening in the field, this way you can improve audits.",
		solucion_1:
			"Increase customer satisfaction with more informed distribution information.",
		solucion_2:
			"Assess driver’s behavior to protect cargo and distribution units.",
		solucion_3:
			"Track and fulfill routes in real time from the mobile app or web.",
		solucion_4: "Reduction of paper by digitizing logs for drivers.",
		solucion_5:
			"Increase fuel efficiency by controlling driving activity (time on route and idle).",
		solucion_6: "Reduce logistical hassles after unplanned shipments.",
		caracteristica_red_title: "FEATURES",
		caracteristica_bold_text:
			"Knowing where your drivers are at any time can help you ship more efficiently, improve customer service, and spend less time calling drivers for updates.",
		caracteristica_list: [
			{
				text: "Location system via GPS and mobile devices.",
				column: "1",
			},
			{
				text: "Addition of geofences, points of interests and routes.",
				column: "1",
			},
			{
				text: "Vehicle visibility on digital maps and satellite photos (Google Maps and OSM).",
				column: "1",
			},
			{
				text: "Deliver a better ETA to your customer.",
				column: "1",
			},
			{
				text: "Mobile app for drivers that collects proof of delivery (POD): photos of deliveries, customer signatures, satisfaction surveys, and incidents.",
				column: "1",
			},
			{
				text: "Guide drivers with exact customer address on digital maps on any device.",
				column: "1",
			},
			{
				text: "Variety of driver and fleet management reports.",
				column: "1",
			},
			{
				text: "Schedule report sending.",
				column: "2",
			},
			{
				text: "Real time security and logistic incidents alerts.",
				column: "2",
			},
			{
				text: "Device tampering detection and remote vehicle shutdown.",
				column: "2",
			},
			{
				text: "Handling of different types of vehicles.",
				column: "2",
			},
			{
				text: "Management of driving hours per driver.",
				column: "2",
			},
			{
				text: "User management by roles.",
				column: "2",
			},
		],
		funcionalidades_red_title: "SPECIAL FUNCTIONALITIES",
		funcionalidades_bold_text:
			"ForesightGPS has developed integration with different kinds of peripherals and sensors of the widest range of brands, models, and functionalities.",
		funcionalidades_text: [
			"This allows the system great versatility and remote control of variables and sets of actions.",
			"From the detection of atypical fuel consumption, going through a detailed report of the behavior of the engine and measurements of variations in temperature of refrigerated cargo; ForesightGPS can make new developments to integrate any other type of device.",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Designed to display key performance indicators quickly and efficiently, facilitating      decision making when faced with large volumes of data.",
		dashboard_text: [
			"With different sets of dashboards allow you to view fleet average, maximum and average speed, milage per unit, average of fuel consumption of the fleet or individual, engine running hours, and more.",
			"Also can be customized to the specific needs of operation, including new data sets.",
		],
		dashboard_list: [
			"Data processing.",
			"Graphic presentation of results.",
			"Comparison of results between different vehicles.",
			"Out of range variable identifier.",
			"Friendly and easy-to-read graphical interface.",
			"Simultaneous control of multiple variables.",
			"Information on driver, vehicle, and fleet.",
		],
		rutas_bold_text:
			"Keeping track of drivers’ routes helps you complete more tasks in less time all while keeping your customers happy and reducing operating costs.",
		rutas_text: [
			"The daily planning does not have to be a headache with our route center module, it increases punctuality in deliveries and efficient management.",
			"Thought planning, design, and routing, manage your fleets work efficiently.",
			"Track the routes and daily activities of the fleet in real time or through reports, validating the fulfillment of tasks.",
		],
		rutas_list: [
			"Mapping clients and dispatch areas.",
			"Route creation.",
			"Visit planning.",
			"Verification of visit patterns.",
			"Variety of executed reports.",
			"Viewing screen of management process.",
		],
	},
};

export default language;